"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var storage_service_1 = require("./storage.service");
var pack_level_service_1 = require("./pack-level.service");
var tool_service_1 = require("./tool.service");
var core_2 = require("angular2-cookie/core");
var constants_1 = require("../constants");
var level_permutation_analyzer_service_1 = require("./level-permutation-analyzer.service");
var ProgressService = (function () {
    function ProgressService(storageService, packLevelService, cookieService, toolService, levelPermutationAnalyzerService) {
        this.storageService = storageService;
        this.packLevelService = packLevelService;
        this.cookieService = cookieService;
        this.toolService = toolService;
        this.levelPermutationAnalyzerService = levelPermutationAnalyzerService;
        this.version = constants_1.VERSION;
        this.sharedPreferences = {};
        this.playedLevels = [];
        this.unlockedLevels = [];
        this.skippedLevels = [];
        this.levelsResults = {};
        this.addedLevelIds = [];
        this.auxiliaryTools = ['HandTool', 'PointTool', 'IntersectTool'];
        this.basicTools = ['LineTool', 'CircleTool'];
        this.LAST_PLAYED_LEVEL_STR = 'LastPlayedLevel';
        this.NEW_LEVEL_IDS_STR = 'newLevelIds';
        this.EXISTED_LEVEL_IDS_STR = 'existedLevelIds';
        this.GM_APP_VERSION_STR = 'GMAppVersion';
        this.originalNewLevelsCount = 0;
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        this.baseLevelIds = [];
        this.init();
    }
    ProgressService.prototype.init = function () {
        this.loadSharedPreferences();
        if (this.cookieService.get('MGSession')) {
            this.unzipSession(this.cookieService.get('MGSession'));
            this.cookieService.put('MGSession', '');
        }
        if (!this.loadLevelResults()) {
            this.saveLevelsResults();
        }
        if (!this.loadUnlockedLevels()) {
            this.saveUnlockedLevels();
        }
        if (!this.loadPlayedLevels()) {
            this.savePlayedLevels();
        }
        if (!this.loadSkippedLevels()) {
            this.saveSkippedLevels();
        }
        if (this.unlockedLevels == null || this.unlockedLevels.length == 0) {
            this.unlockedLevels = this.baseOpenedLevelIds();
        }
        this.baseLevelIds = this.baseOpenedLevelIds();
        this.removeNonexistentLevelResults();
        this.calculateStarsForExistedResults();
        this.lockUnlockLevelsIfNeeded();
        this.loadAddedLevels();
        if (this.isNewVersion()) {
            this.checkForNewLevels();
        }
        this.initFinished = true;
    };
    ProgressService.prototype.lockUnlockLevelsIfNeeded = function () {
        var allLevelIds = this.packLevelService.levelIds;
        this.levelPermutationAnalyzerService.analize(allLevelIds, this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR]);
        this.findLevelIdsToUnlockOrLockForLevels(allLevelIds);
        this.unlockLevelsWithIds(this.levelsToUnlock);
        this.lockLevelsWithIds(this.levelsToLock);
        this.skipLevelsWithIds(this.levelsToSkip);
    };
    ProgressService.prototype.findLevelIdsToUnlockOrLockForLevels = function (levels) {
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        var lastOpenedOldLevelIndex = this.getLastOpenedLevelIndex(levels);
        var firstLockedOldLevelIndex = this.getFirstLockedLevelIndex(levels);
        if ((lastOpenedOldLevelIndex != null) && (firstLockedOldLevelIndex != null) && (firstLockedOldLevelIndex <= lastOpenedOldLevelIndex)) {
            if (lastOpenedOldLevelIndex < levels.length - 1) {
                firstLockedOldLevelIndex = lastOpenedOldLevelIndex + 1;
            }
            else {
                firstLockedOldLevelIndex = null;
            }
        }
        if (firstLockedOldLevelIndex !== null) {
            for (var i = firstLockedOldLevelIndex; i < levels.length; i++) {
                var levelId = levels[i];
                if (!this.isLevelLocked(levelId)) {
                    this.levelsToLock.push(levelId);
                }
            }
        }
        if (lastOpenedOldLevelIndex !== null) {
            for (var i = lastOpenedOldLevelIndex; i >= 0; i--) {
                var levelId = levels[i];
                if (this.isLevelLocked(levelId)) {
                    this.levelsToUnlock.push(levelId);
                }
            }
        }
        this.levelsToSkip = this.levelsToSkip.concat(this.levelsToUnlock);
        if (lastOpenedOldLevelIndex == null || firstLockedOldLevelIndex == null) {
            return;
        }
        var lastOpenedLevelId = levels[lastOpenedOldLevelIndex];
        var isLastOpenedLevelSolved = this.levelsResults[lastOpenedLevelId];
        if (isLastOpenedLevelSolved) {
            var lastOpenedOldLevelPack = this.packLevelService.packWithLevelId(lastOpenedLevelId);
            var firstLockedLevelId = levels[firstLockedOldLevelIndex];
            var firstLockedOldLevelPack = this.packLevelService.packWithLevelId(firstLockedLevelId);
            var arePacksSame = lastOpenedOldLevelPack.packId === firstLockedOldLevelPack.packId;
            var additionalLevelIdsToUnlock = [];
            if (!arePacksSame) {
                var firstLevelInLockedPack = firstLockedOldLevelPack.levelIds[0];
                var firstLevelIndex = levels.indexOf(firstLevelInLockedPack);
                for (var i = lastOpenedOldLevelIndex; i < firstLevelIndex; i++) {
                    var levelId = levels[i];
                    if (this.isLevelLocked(levelId)) {
                        additionalLevelIdsToUnlock.push(levelId);
                    }
                }
                this.levelsToSkip = this.levelsToSkip.concat(additionalLevelIdsToUnlock);
                additionalLevelIdsToUnlock.push(firstLevelInLockedPack);
            }
            this.levelsToUnlock = this.levelsToUnlock.concat(additionalLevelIdsToUnlock);
            if (additionalLevelIdsToUnlock.length) {
                return;
            }
            var lastLevelIdInOpenedPack = lastOpenedOldLevelPack.levelIds[lastOpenedOldLevelPack.levelIds.length - 1];
            if (lastOpenedLevelId === lastLevelIdInOpenedPack) {
                return;
            }
            var nextLevelId = levels[lastOpenedOldLevelIndex + 1];
            if (this.isLevelLocked(nextLevelId)) {
                this.levelsToUnlock.push(nextLevelId);
            }
        }
        else {
            for (var i = lastOpenedOldLevelIndex + 1; i < firstLockedOldLevelIndex; i++) {
                this.levelsToLock.push(levels[i]);
            }
        }
    };
    ProgressService.prototype.getLastOpenedLevelIndex = function (levels) {
        if (!levels || !levels.length) {
            return null;
        }
        var index;
        for (var i = levels.length - 1; i >= 0; i--) {
            var levelId = levels[i];
            if (!this.isLevelLocked(levelId) && !this.isLevelNewOrRearranged(levelId)) {
                index = i;
                break;
            }
        }
        return index;
    };
    ProgressService.prototype.getFirstLockedLevelIndex = function (levels) {
        if (!levels || !levels.length) {
            return null;
        }
        var index;
        for (var i = 0; i < levels.length; i++) {
            var levelId = levels[i];
            if (this.isLevelLocked(levelId) && !this.isLevelNewOrRearranged(levelId)) {
                index = i;
                break;
            }
        }
        return index;
    };
    ProgressService.prototype.isLevelNewOrRearranged = function (levelId) {
        return this.levelPermutationAnalyzerService.addedLevelIds.indexOf(levelId) !== -1 || this.levelPermutationAnalyzerService.rearrangedLevelIds.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.lockLevelsWithIds = function (levels) {
        if (!levels || !levels.length) {
            return;
        }
        for (var _i = 0, levels_1 = levels; _i < levels_1.length; _i++) {
            var levelId = levels_1[_i];
            this.removeUnlockedLevel(levelId);
            this.removeLevelResult(levelId);
            this.removeSkippedLevel(levelId);
        }
    };
    ProgressService.prototype.removeUnlockedLevel = function (levelId) {
        var index = this.unlockedLevels.indexOf(levelId);
        if (index !== -1) {
            this.unlockedLevels.splice(index, 1);
        }
        this.saveUnlockedLevels();
    };
    ProgressService.prototype.removeLevelResult = function (levelId) {
        delete this.levelsResults[levelId];
        this.saveLevelsResults();
    };
    ProgressService.prototype.removeSkippedLevel = function (levelId) {
        delete this.skippedLevels[levelId];
        this.saveSkippedLevels();
    };
    ProgressService.prototype.skipLevelsWithIds = function (levelIds) {
        for (var _i = 0, levelIds_1 = levelIds; _i < levelIds_1.length; _i++) {
            var levelId = levelIds_1[_i];
            this.skipLevel(levelId);
        }
    };
    ProgressService.prototype.isLevelLocked = function (levelId) {
        return this.unlockedLevels.indexOf(levelId) === -1;
    };
    ProgressService.prototype.setLastPlayedLevelId = function (lastPlayedLevelId) {
        this.sharedPreferences[this.LAST_PLAYED_LEVEL_STR] = lastPlayedLevelId;
        this.saveSharedPreferences();
        if (lastPlayedLevelId == null) {
            return;
        }
        if (this.playedLevels.indexOf(lastPlayedLevelId) == -1) {
            this.unmarkLevel(lastPlayedLevelId);
            this.playedLevels.push(lastPlayedLevelId);
            this.savePlayedLevels();
        }
    };
    ProgressService.prototype.toolTypesAvailableForLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        var levelTools = level.allowedToolTypes.slice();
        if (levelTools.length == 0) {
            levelTools = this.unlockedToolsForLevel(levelId);
        }
        if (!level.tutorial) {
            for (var _i = 0, _a = this.auxiliaryTools; _i < _a.length; _i++) {
                var auxTool = _a[_i];
                if (levelTools.indexOf(auxTool) == -1) {
                    levelTools.push(auxTool);
                }
            }
        }
        this.sortTools(levelTools);
        return levelTools;
    };
    ProgressService.prototype.toolTypesAvailableForExploreForLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        var levelTools = this.unlockedToolsForLevel(levelId);
        var availableTools = levelTools.slice();
        if (!level.tutorial) {
            for (var _i = 0, _a = this.auxiliaryTools; _i < _a.length; _i++) {
                var auxTool = _a[_i];
                if (availableTools.indexOf(auxTool) == -1) {
                    availableTools.push(auxTool);
                }
            }
        }
        this.sortTools(availableTools);
        return availableTools;
    };
    ProgressService.prototype.unlockedToolsForLevel = function (levelId) {
        var toolTypes = this.basicTools.slice();
        var levelIds = this.packLevelService.levelIds;
        var currentLevelNum = levelIds.indexOf(levelId);
        for (var i = 0; i < currentLevelNum; i++) {
            var tempLevelId = levelIds[i];
            var keys = Object.keys(this.levelsResults);
            var level = this.packLevelService.levels[tempLevelId];
            if (level.unlockedToolType != undefined) {
                if (toolTypes.indexOf(level.unlockedToolType) == -1) {
                    toolTypes.push(level.unlockedToolType);
                }
            }
        }
        return toolTypes;
    };
    ProgressService.prototype.totalStarsEarned = function () {
        var totalStars = 0;
        var keys = Object.keys(this.levelsResults);
        for (var i = 0; i < keys.length; i++) {
            var levelResult = this.levelsResults[keys[i]];
            totalStars += levelResult.stars.length;
        }
        return totalStars;
    };
    ProgressService.prototype.unlockAllLevels = function () {
        var levelToUnlock = [];
        var allLevelIds = this.packLevelService.levelIds;
        for (var i = 0; i < allLevelIds.length; i++) {
            var levelId = allLevelIds[i];
            if (this.isLevelLocked(levelId)) {
                if (levelToUnlock.indexOf(levelId))
                    levelToUnlock.push(levelId);
            }
            this.skipLevel(levelId);
        }
        this.unlockLevelsWithIds(levelToUnlock);
    };
    ProgressService.prototype.saveSharedPreferences = function () {
        this.storageService.save('SharedPreferences', this.sharedPreferences);
    };
    ProgressService.prototype.isPackLocked = function (packId) {
        var pack = this.packLevelService.packs[packId];
        for (var _i = 0, _a = pack.levelIds; _i < _a.length; _i++) {
            var levelId = _a[_i];
            if (!this.isLevelLocked(levelId)) {
                return false;
            }
        }
        return true;
    };
    ProgressService.prototype.starsEarnedWithPackId = function (packId) {
        var pack = this.packLevelService.packs[packId];
        var starsInPack = 0;
        for (var i = 0; i < pack.levelIds.length; i++) {
            var levelId = pack.levelIds[i];
            var result = this.levelsResults[levelId];
            if (result != null) {
                starsInPack += result.stars.length;
            }
        }
        return starsInPack;
    };
    ProgressService.prototype.registerResultForLevel = function (result, levelId) {
        if (this.skippedLevels != null && this.skippedLevels.indexOf(levelId) != -1) {
            this.skippedLevels.splice(this.skippedLevels.indexOf(levelId), 1);
            this.saveSkippedLevels();
        }
        var existedResult = this.levelsResults[levelId];
        result.justEarnedStars = [];
        if (existedResult == null) {
            this.levelsResults[levelId] = result;
            result.justEarnedStars = result.stars.slice();
            this.saveLevelsResults();
            var level = this.packLevelService.levels[levelId];
            this.didCompleteNewLevel(level);
            this.notifyIfCompletePack(result.levelId);
            return;
        }
        if (existedResult.e_moves > result.e_moves || existedResult.l_moves > result.l_moves || existedResult.v_count < result.v_count) {
            existedResult.e_moves = Math.min(existedResult.e_moves, result.e_moves);
            existedResult.l_moves = Math.min(existedResult.l_moves, result.l_moves);
            existedResult.v_count = Math.max(existedResult.v_count, result.v_count);
            var stars = result.stars.slice();
            for (var i = 0; i < existedResult.stars.length; i++) {
                var exStar = existedResult.stars[i];
                if (stars.indexOf(exStar) == -1) {
                    stars.push(exStar);
                }
            }
            var newStars = result.stars.slice();
            for (var i = 0; i < existedResult.stars.length; i++) {
                var curStar = existedResult.stars[i];
                if (newStars.indexOf(curStar) != -1) {
                    newStars.splice(newStars.indexOf(curStar), 1);
                }
            }
            existedResult.stars = stars;
            existedResult.date = result.date;
            result.justEarnedStars = newStars;
            this.saveLevelsResults();
            this.notifyIfCompletePack(result.levelId);
        }
    };
    ProgressService.prototype.isNewVersion = function () {
        var previousVersion = this.sharedPreferences[this.GM_APP_VERSION_STR];
        if (this.version == previousVersion) {
            return false;
        }
        else {
            this.sharedPreferences[this.GM_APP_VERSION_STR] = this.version;
            this.saveSharedPreferences();
            return true;
        }
    };
    ProgressService.prototype.resetProgress = function () {
        this.storageService.remove('LevelsResult');
        this.storageService.remove('PlayedLevels');
        this.storageService.remove('SkippedLevels');
        this.storageService.remove('UnlockedLevels');
        this.storageService.remove('ExploreModeAlreadyShown');
        this.storageService.remove('CircleHintAlreadyShown');
        this.levelsResults = {};
        this.playedLevels = [];
        this.skippedLevels = [];
        this.unlockedLevels = [];
        this.levelsToUnlock = [];
        this.levelsToLock = [];
        this.levelsToSkip = [];
        this.init();
    };
    ProgressService.prototype.isLevelPlayed = function (levelId) {
        return this.playedLevels.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.baseOpenedLevelIds = function () {
        var baseTutIds = [];
        var levelIds = this.packLevelService.levelIds;
        for (var i = 0; i < levelIds.length; i++) {
            var levelId = levelIds[i];
            baseTutIds.push(levelId);
            if (levelId === this.packLevelService.GM_OPENED_MAX_LEVEL_ID) {
                return baseTutIds;
            }
        }
        return baseTutIds;
    };
    ProgressService.prototype.isLevelBaseOpened = function (levelId) {
        return this.baseLevelIds.indexOf(levelId) !== -1;
    };
    ProgressService.prototype.loadSharedPreferences = function () {
        var data = this.storageService.getObject('SharedPreferences');
        if (data == null) {
            return false;
        }
        this.sharedPreferences = data;
    };
    ProgressService.prototype.unzipSession = function (string) {
        var parts = string.split('||');
        this.sharedPreferences.local = parts[2];
        string = parts[3];
        var levels = string.split('|');
        for (var _i = 0, levels_2 = levels; _i < levels_2.length; _i++) {
            var lvlstr = levels_2[_i];
            var lvlarr = lvlstr.split('/');
            lvlarr[1] = parseInt(lvlarr[1]);
            var levelResult = {};
            levelResult.levelId = lvlarr[0];
            levelResult.date = new Date();
            levelResult.e_moves = lvlarr[2];
            levelResult.l_moves = lvlarr[3];
            levelResult.stars = [];
            if (lvlarr[1] > 1) {
                levelResult.stars.push('GM_STAR_TYPE_B');
                if (!!(lvlarr[1] & 1)) {
                    levelResult.stars.push('GM_STAR_TYPE_L');
                }
                lvlarr[1] = lvlarr[1] >> 1;
                if (!!(lvlarr[1] & 1)) {
                    levelResult.stars.push('GM_STAR_TYPE_E');
                }
            }
            if (this.unlockedLevels.indexOf(levelResult.levelId) == -1) {
                this.unlockedLevels.push(levelResult.levelId);
            }
            if (lvlarr[1] != 0) {
                if (this.playedLevels.indexOf(levelResult.levelId) == -1) {
                    this.playedLevels.push(levelResult.levelId);
                }
                this.registerResultForLevel(levelResult, levelResult.levelId);
            }
        }
        this.savePlayedLevels();
        this.saveUnlockedLevels();
        this.saveSharedPreferences();
    };
    ProgressService.prototype.savePlayedLevels = function () {
        this.storageService.save('PlayedLevels', this.playedLevels);
    };
    ProgressService.prototype.saveUnlockedLevels = function () {
        this.storageService.save('UnlockedLevels', this.unlockedLevels);
    };
    ProgressService.prototype.loadLevelResults = function () {
        var data = this.storageService.getArray('LevelsResult');
        if (data == null) {
            return false;
        }
        this.levelsResults = data;
    };
    ProgressService.prototype.saveLevelsResults = function () {
        this.storageService.save('LevelsResult', this.levelsResults);
    };
    ProgressService.prototype.loadUnlockedLevels = function () {
        var data = this.storageService.getArray('UnlockedLevels');
        if (data == null) {
            return false;
        }
        this.unlockedLevels = data;
    };
    ProgressService.prototype.loadPlayedLevels = function () {
        var data = this.storageService.getArray('PlayedLevels');
        if (data == null) {
            return false;
        }
        this.playedLevels = data;
    };
    ProgressService.prototype.loadSkippedLevels = function () {
        var data = this.storageService.getArray('SkippedLevels');
        if (data == null) {
            return false;
        }
        this.skippedLevels = data;
    };
    ProgressService.prototype.saveSkippedLevels = function () {
        this.storageService.save('SkippedLevels', this.skippedLevels);
    };
    ProgressService.prototype.sortTools = function (toolTypes) {
        var orderedTools = this.toolService.allToolTypes();
        toolTypes.sort(function (obj1, obj2) {
            var index1 = orderedTools.indexOf(obj1);
            var index2 = orderedTools.indexOf(obj2);
            return index1 < index2 ? -1 : 1;
        });
    };
    ProgressService.prototype.removeNonexistentLevelResults = function () {
        var allLevelIds = this.packLevelService.levelIds;
        var toRemove = [];
        var levelId;
        for (var i = 0; i < this.unlockedLevels.length; i++) {
            levelId = this.unlockedLevels[i];
            if (allLevelIds.indexOf(levelId) == -1 && toRemove.indexOf(levelId) != -1) {
                toRemove.push(levelId);
            }
        }
        if (toRemove.length == 0) {
            return;
        }
        var keys = Object.keys(this.unlockedLevels);
        for (var i = 0; i < toRemove.length; i++) {
            this.unlockedLevels.splice(this.unlockedLevels.indexOf(levelId), 1);
            if (keys.indexOf(levelId) != -1) {
                this.levelsResults.splice(this.levelsResults.indexOf(levelId), 1);
            }
            if (this.playedLevels != null && this.playedLevels.indexOf(levelId) != -1) {
                this.playedLevels.splice(this.playedLevels.indexOf(levelId), 1);
            }
        }
        this.saveLevelsResults();
        this.saveUnlockedLevels();
        this.savePlayedLevels();
        this.saveSkippedLevels();
    };
    ProgressService.prototype.calculateStarsForExistedResults = function () {
        var keys = Object.keys(this.levelsResults);
        for (var i = 0; i < keys.length; i++) {
            var levelId = keys[i];
            var result = this.levelsResults[levelId];
            var level = this.packLevelService.levels[levelId];
            if (!level) {
                continue;
            }
            ;
            result.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(result.e_moves, result.l_moves, result.v_count);
        }
    };
    ProgressService.prototype.loadAddedLevels = function () {
        var data = this.sharedPreferences[this.NEW_LEVEL_IDS_STR];
        if (data != null) {
            this.addedLevelIds = new Array(data);
        }
        else {
            this.addedLevelIds = [];
        }
    };
    ProgressService.prototype.checkForNewLevels = function () {
        this.findNewLevelIds();
        this.unmarkNewLocked();
    };
    ProgressService.prototype.findNewLevelIds = function () {
        var currentLevelIds = this.packLevelService.levelIds.slice();
        var existedLevelIds = this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR];
        this.sharedPreferences[this.EXISTED_LEVEL_IDS_STR] = currentLevelIds.slice();
        if (existedLevelIds == null) {
            this.saveSharedPreferences();
            return;
        }
        // get diff with previous version
        for (var i = 0; i < existedLevelIds.length; i++) {
            var levelId = existedLevelIds[i];
            currentLevelIds.splice(currentLevelIds.indexOf(levelId), 1);
        }
        this.originalNewLevelsCount = currentLevelIds.length;
        // union old_new with new new
        for (var i = 0; i < this.originalNewLevelsCount; i++) {
            var levelId = currentLevelIds[i];
            if (this.addedLevelIds.indexOf(levelId) == -1) {
                this.addedLevelIds.push(levelId);
            }
        }
        this.sharedPreferences[this.NEW_LEVEL_IDS_STR] = this.addedLevelIds;
        this.saveSharedPreferences();
    };
    ProgressService.prototype.unmarkNewLocked = function () {
        var levelsToUnmark = [];
        var i;
        for (i = 0; i < this.addedLevelIds.length; i++) {
            var levelId = this.addedLevelIds[i];
            if (this.isLevelLocked(levelId) && levelsToUnmark.indexOf(levelId) != -1) {
                levelsToUnmark.push(levelId);
            }
        }
        for (i = 0; i < levelsToUnmark; i++) {
            var lvlId = levelsToUnmark[i];
            this.unmarkLevel(lvlId);
        }
    };
    ProgressService.prototype.unmarkLevel = function (levelId) {
        if (this.addedLevelIds.indexOf(levelId) === -1) {
            return;
        }
        this.addedLevelIds.splice(this.addedLevelIds.indexOf(levelId), 1);
        this.sharedPreferences[this.NEW_LEVEL_IDS_STR] = this.addedLevelIds;
        this.saveSharedPreferences();
    };
    ProgressService.prototype.unlockLevelsWithIds = function (levels) {
        if (levels == undefined || levels.length == 0) {
            return;
        }
        for (var i = 0; i < levels.length; i++) {
            if (this.unlockedLevels.indexOf(levels[i]) == -1) {
                this.unlockedLevels.push(levels[i]);
            }
        }
        this.saveUnlockedLevels();
    };
    ProgressService.prototype.didCompleteNewLevel = function (level) {
        this.unlockLevelsWithIds(this.dependentLevelsOfLevel(level.levelId));
    };
    ProgressService.prototype.dependentLevelsOfLevel = function (levelId) {
        var dependentLevels = [];
        var nextLevelId = this.packLevelService.nextLevelId(levelId);
        if (nextLevelId != undefined && !(this.unlockedLevels.indexOf(nextLevelId) != -1)) {
            if (dependentLevels.indexOf(nextLevelId) == -1) {
                dependentLevels.push(nextLevelId);
            }
        }
        return dependentLevels;
    };
    ProgressService.prototype.notifyIfCompletePack = function (levelId) {
        var pack = this.packLevelService.packWithLevelId(levelId);
        var earnedStars = this.starsEarnedWithPackId(pack.packId);
        var limitStars = this.packLevelService.starsCountForPackId(pack.packId);
        if (earnedStars != limitStars) {
            return;
        }
    };
    ProgressService.prototype.skipLevel = function (levelId) {
        var level = this.packLevelService.levels[levelId];
        if (this.skippedLevels.indexOf(levelId) == -1) {
            this.skippedLevels.push(levelId);
        }
        this.unlockLevelsWithIds(this.dependentLevelsOfLevel(levelId));
        this.saveSkippedLevels();
        this.saveUnlockedLevels();
    };
    //Level is available to be skipped if:
    //1. Next level is locked;
    //2. Packs are opened;
    //3. It's not last level of pack
    //4. If not, next pack is free;
    //5. If not, all stars are gained.
    ProgressService.prototype.isAvailableToSkip = function (levelId) {
        //1. Next level is locked;
        var nextLevelId = this.packLevelService.nextLevelId(levelId);
        if (!this.isLevelLocked(nextLevelId)) {
            return false;
        }
        return true;
    };
    ProgressService.prototype.updateProgressBySync = function (progress) {
        var levelIds = this.packLevelService.levelIds;
        var playedLevels = [];
        var unlockedLevels = [];
        var levelResults = [];
        var currentResultsIds = Object.keys(this.levelsResults);
        var syncResultsObj = this.prepareResultsObj(progress.level_results);
        for (var i = 0, len = levelIds.length; i < len; i++) {
            var levelId = levelIds[i];
            var shouldStop = true;
            var existedResultIx = currentResultsIds.indexOf(levelId);
            var existedResult = existedResultIx > -1 ? this.levelsResults[levelId] : null;
            if (existedResult) {
                var resultToSync = syncResultsObj[levelId];
                if (!resultToSync) {
                    continue;
                }
                var level = this.packLevelService.levels[levelId];
                existedResult.e_moves = Math.min(existedResult.e_moves, resultToSync.e_moves);
                existedResult.l_moves = Math.min(existedResult.l_moves, resultToSync.l_moves);
                existedResult.v_count = Math.max(existedResult.v_count, resultToSync.v_count);
                existedResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(existedResult.e_moves, existedResult.l_moves, existedResult.v_count);
                shouldStop = false;
            }
            else {
                var canPrevBeSkipped = this.canPreviousLevelBeSkipped(levelId);
                var isLocked = this.isLevelLocked(levelId);
                if (!canPrevBeSkipped && isLocked) {
                    break;
                }
                var resultToSync = syncResultsObj[levelId];
                // save result if needed
                if (resultToSync) {
                    this.addOrUpdateLevelResult(resultToSync);
                    this.setLevelSkipped(levelId, false);
                    shouldStop = false;
                }
                // skip if needed
                if (progress.skipped_levels.indexOf(levelId) > -1 && !resultToSync) {
                    this.setLevelSkipped(levelId, true);
                    shouldStop = false;
                }
                // unlock if needed
                if (progress.unlocked_levels.indexOf(levelId) > -1) {
                    this.setLevelUnlocked(levelId, true);
                }
                if (shouldStop && this.isLevelBaseOpened(levelId)) {
                    // we shouldn't stop at first tutorials
                    shouldStop = false;
                }
            }
            if (shouldStop) {
                break;
            }
        }
        if (progress.played_levels.length) {
            for (var _i = 0, _a = progress.played_levels; _i < _a.length; _i++) {
                var levelId = _a[_i];
                if (levelIds.indexOf(levelId) > -1) {
                    this.setLevelPlayed(levelId, true);
                }
            }
        }
        this.lockUnlockLevelsIfNeeded();
        this.saveLevelsResults();
        this.saveUnlockedLevels();
        this.savePlayedLevels();
        this.saveSkippedLevels();
    };
    ProgressService.prototype.prepareResultsObj = function (arr) {
        var obj = {};
        for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
            var el = arr_1[_i];
            obj[el.level_id] = el;
        }
        return obj;
    };
    ProgressService.prototype.canPreviousLevelBeSkipped = function (levelId) {
        var canBeSkipped = true;
        var prevLevelId = this.packLevelService.previousLevelId(levelId);
        if (prevLevelId) {
            var isPreviousAvailableToSkip = this.isAvailableToSkip(prevLevelId);
            var isPreviousTutorial = this.packLevelService.levels[prevLevelId].tutorial;
            canBeSkipped = isPreviousAvailableToSkip || isPreviousTutorial;
        }
        return canBeSkipped;
    };
    ProgressService.prototype.addOrUpdateLevelResult = function (levelResult) {
        var foundResult = this.levelsResults[levelResult.level_id];
        var level = this.packLevelService.levels[levelResult.level_id];
        if (foundResult) {
            foundResult.e_moves = Math.min(foundResult.e_moves, levelResult.e_moves);
            foundResult.l_moves = Math.min(foundResult.l_moves, levelResult.l_moves);
            foundResult.v_count = Math.max(foundResult.v_count, levelResult.v_count);
            foundResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(foundResult.e_moves, foundResult.l_moves, foundResult.v_count);
        }
        else {
            levelResult.stars = level.starsForSolutionWithElementaryMovesLineMovesVariantsFound(levelResult.e_moves, levelResult.l_moves, levelResult.v_count);
            if (levelResult.level_id) {
                levelResult.levelId = levelResult.level_id;
                delete levelResult.level_id;
            }
            this.levelsResults[levelResult.levelId] = levelResult;
        }
    };
    ProgressService.prototype.setLevelSkipped = function (levelId, isSkipped) {
        var ix = this.skippedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isSkipped) {
                return;
            }
            this.skippedLevels.splice(ix, 1);
        }
        else {
            if (isSkipped) {
                this.skippedLevels.push(levelId);
            }
        }
    };
    ProgressService.prototype.setLevelUnlocked = function (levelId, isUnlocked) {
        var ix = this.unlockedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isUnlocked) {
                return;
            }
            this.unlockedLevels.splice(ix, 1);
        }
        else {
            if (isUnlocked) {
                this.unlockedLevels.push(levelId);
            }
        }
    };
    ProgressService.prototype.setLevelPlayed = function (levelId, isPlayed) {
        var ix = this.playedLevels.indexOf(levelId);
        if (ix > -1) {
            if (isPlayed) {
                return;
            }
            this.playedLevels.splice(ix, 1);
        }
        else {
            if (isPlayed) {
                this.playedLevels.push(levelId);
            }
        }
    };
    return ProgressService;
}());
ProgressService = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [storage_service_1.StorageService,
        pack_level_service_1.PackLevelService,
        core_2.CookieService,
        tool_service_1.ToolService,
        level_permutation_analyzer_service_1.LevelPermutationAnalyzerService])
], ProgressService);
exports.ProgressService = ProgressService;



//////////////////
// WEBPACK FOOTER
// ./src/services/progress.service.ts
// module id = 145
// module chunks = 0